module.exports = __webpack_public_path__ + "static/08-ec37f8efe7a33ba03fa32e9ed7d07ed6.jpg";